var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayPanel
    ? _c(
        "CompassPanel",
        {
          staticClass: "address-form-panel",
          attrs: {
            value: true,
            title: _vm.panelTitle,
            primaryAction: _vm.primaryAction,
            secondaryActions: _vm.secondaryAction
          },
          on: { beforeClose: _vm.handleClose }
        },
        [
          _c(
            "div",
            { staticClass: "address-form-panel__input-container" },
            [
              _vm.isLoading
                ? [
                    _c("CompassSkeleton", { attrs: { size: "x-large" } }),
                    _vm._v(" "),
                    _c("CompassSkeleton", { attrs: { variant: "block" } }),
                    _vm._v(" "),
                    _vm.address
                      ? _c("CompassSkeleton", { attrs: { size: "x-large" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.address
                      ? _c("CompassSkeleton", { attrs: { size: "x-large" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.address
                      ? _c("CompassSkeleton", { attrs: { size: "x-large" } })
                      : _vm._e()
                  ]
                : [
                    _c(
                      "CompassFormItem",
                      {
                        staticClass: "address-form-panel__address-name",
                        attrs: {
                          label: _vm.$t.__("common.labels.address_name"),
                          orientation: "horizontal",
                          info: _vm.$t.__("common.labels.info_address_name"),
                          error: _vm.errors.addressName
                        }
                      },
                      [
                        _c("CompassInput", {
                          attrs: { error: !!_vm.errors.addressName },
                          on: {
                            input: function($event) {
                              _vm.errors.addressName = ""
                            }
                          },
                          model: {
                            value: _vm.localAddress.name,
                            callback: function($$v) {
                              _vm.$set(_vm.localAddress, "name", $$v)
                            },
                            expression: "localAddress.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.manualMode
                      ? _c("AutocompleteAddress", {
                          attrs: {
                            orientation: "horizontal",
                            errorMsg: _vm.errors.address_line_1
                          },
                          on: {
                            "update:address": function($event) {
                              _vm.localAddress = Object.assign(
                                {},
                                _vm.localAddress,
                                $event
                              )
                            },
                            input: function($event) {
                              _vm.errors.address_line_1 = ""
                            }
                          }
                        })
                      : [
                          _c(
                            "CompassFormItem",
                            {
                              staticClass:
                                "address-form-panel__create-manual-street",
                              attrs: {
                                label: _vm.$t.__("common.labels.address"),
                                orientation: "horizontal",
                                error: _vm.addressErrors
                              }
                            },
                            [
                              _c("CompassInput", {
                                attrs: { error: !!_vm.errors.address_line_1 },
                                on: {
                                  input: function($event) {
                                    _vm.errors.address_line_1 = ""
                                  }
                                },
                                model: {
                                  value: _vm.localAddress.address_line_1,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.localAddress,
                                      "address_line_1",
                                      $$v
                                    )
                                  },
                                  expression: "localAddress.address_line_1"
                                }
                              }),
                              _vm._v(" "),
                              _c("CompassInput", {
                                attrs: { error: !!_vm.errors.address_line_2 },
                                on: {
                                  input: function($event) {
                                    _vm.errors.address_line_2 = ""
                                  }
                                },
                                model: {
                                  value: _vm.localAddress.address_line_2,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.localAddress,
                                      "address_line_2",
                                      $$v
                                    )
                                  },
                                  expression: "localAddress.address_line_2"
                                }
                              }),
                              _vm._v(" "),
                              _c("CompassInput", {
                                attrs: { error: !!_vm.errors.address_line_3 },
                                on: {
                                  input: function($event) {
                                    _vm.errors.address_line_3 = ""
                                  }
                                },
                                model: {
                                  value: _vm.localAddress.address_line_3,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.localAddress,
                                      "address_line_3",
                                      $$v
                                    )
                                  },
                                  expression: "localAddress.address_line_3"
                                }
                              }),
                              _vm._v(" "),
                              _c("CompassInput", {
                                attrs: { error: !!_vm.errors.address_line_4 },
                                on: {
                                  input: function($event) {
                                    _vm.errors.address_line_4 = ""
                                  }
                                },
                                model: {
                                  value: _vm.localAddress.address_line_4,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.localAddress,
                                      "address_line_4",
                                      $$v
                                    )
                                  },
                                  expression: "localAddress.address_line_4"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "CompassFormItem",
                            {
                              staticClass:
                                "address-form-panel__create-manual-country",
                              attrs: {
                                label: _vm.$t.__("common.labels.country"),
                                orientation: "horizontal",
                                error: _vm.errors.country_code
                              }
                            },
                            [
                              _c(
                                "CompassSelect",
                                {
                                  attrs: {
                                    menuClass: "select-country-code",
                                    error: !!_vm.errors.country_code
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.errors.country_code = ""
                                    }
                                  },
                                  model: {
                                    value: _vm.localAddress.country_code,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.localAddress,
                                        "country_code",
                                        $$v
                                      )
                                    },
                                    expression: "localAddress.country_code"
                                  }
                                },
                                _vm._l(_vm.countries, function(country) {
                                  return _c("CompassDropdownSelectOption", {
                                    key: country.code,
                                    attrs: {
                                      label: country.name,
                                      value: country.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "CompassFormItem",
                            {
                              staticClass:
                                "address-form-panel__create-manual-postal",
                              attrs: {
                                label: _vm.$t.__("common.labels.postal_code"),
                                orientation: "horizontal",
                                error: _vm.errors.postal_code
                              }
                            },
                            [
                              _c("CompassInput", {
                                attrs: { error: !!_vm.errors.postal_code },
                                on: {
                                  input: function($event) {
                                    _vm.errors.postal_code = ""
                                  }
                                },
                                model: {
                                  value: _vm.localAddress.postal_code,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.localAddress,
                                      "postal_code",
                                      $$v
                                    )
                                  },
                                  expression: "localAddress.postal_code"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "CompassFormItem",
                            {
                              staticClass:
                                "address-form-panel__create-manual-city",
                              attrs: {
                                label: _vm.$t.__("common.labels.city"),
                                orientation: "horizontal",
                                error: _vm.errors.city
                              }
                            },
                            [
                              _c("CompassInput", {
                                attrs: { error: !!_vm.errors.city },
                                on: {
                                  input: function($event) {
                                    _vm.errors.city = ""
                                  }
                                },
                                model: {
                                  value: _vm.localAddress.city,
                                  callback: function($$v) {
                                    _vm.$set(_vm.localAddress, "city", $$v)
                                  },
                                  expression: "localAddress.city"
                                }
                              })
                            ],
                            1
                          )
                        ]
                  ]
            ],
            2
          ),
          _vm._v(" "),
          !_vm.manualMode && !_vm.isLoading
            ? _c("CompassPlainButton", {
                staticClass: "address-form-panel__button-switch-mode",
                attrs: {
                  label: _vm.$t.__(
                    "document.DocFormSettingsDialog.FormDeliveryAddress.btn_to_manual_create"
                  )
                },
                on: {
                  click: function($event) {
                    _vm.manualMode = true
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }